import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListSurveyQuestions(authorization) {
  const url = `${API_URL}/survey-question`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function submitSurvey(authorization,data) {
  const url = `${API_URL}/api/v6/home/submit-survey`;
  return axios({
    url,
    method: 'post',
    data: data,
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/survey.js